/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

(window as any).process = { env: { DEBUG: undefined } };
(window as any).global = window;
import { Buffer } from "buffer";
global.Buffer = global.Buffer || Buffer;
/** ngb-toast requires localize component to complete i18n */
import "@angular/localize/init";
/** IE10 and IE11 requires the following to support `@angular/animation`. */
import "zone.js"; // Changed from "zone.js/dist/zone"
